import Result from "@/core/common/Result";

export interface IListarVoucherGatewayResponse {
  voucherId: string;
  dataPrimeiraVisualizacao: string | null;
  duracao: string;
  ativo: boolean;
}

export interface IListarVoucherGateway {
  getVoucher(): Promise<Result<IListarVoucherGatewayResponse>>;
}

export const listarVoucherGatewayDI = "ListarVoucherGatewayDI";
